export default "__VITE_ASSET__BowhSVyb__"